import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/button.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { BUTTON_TYPES, BUTTON_ELEMS, BUTTON_DISPLAYS, BUTTON_SIZES, BUTTON_APPEARANCES } from './types.js';
import { buttonLabelValidator } from '../../prop-types-validators/button-label-validator.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('btn', styles);
function Button(_a) {
  var {
      appearance,
      RouterLink,
      extraClasses,
      innerRef,
      display,
      children,
      size,
      href,
      loading = false,
      type = 'button',
      Elem = 'button'
    } = _a,
    rest = __rest(_a, ["appearance", "RouterLink", "extraClasses", "innerRef", "display", "children", "size", "href", "loading", "type", "Elem"]);
  const buttonProps = Object.assign(Object.assign({
    className: bem.b([appearance, display, size, {
      loading
    }], extraClasses)
  }, loading && {
    'aria-live': 'polite',
    'aria-busy': 'true'
  }), rest);
  if (RouterLink) {
    const routerLinkProps = Object.assign(Object.assign(Object.assign({}, innerRef ? {
      innerRef
    } : {}), buttonProps), rest);
    return /*#__PURE__*/React.createElement(RouterLink, Object.assign({}, routerLinkProps), children);
  }
  if (Elem === 'span') {
    return /*#__PURE__*/React.createElement("span", Object.assign({
      ref: innerRef
    }, buttonProps), children);
  }
  if (Elem === 'a') {
    return /*#__PURE__*/React.createElement("a", Object.assign({
      ref: innerRef,
      href: href
    }, buttonProps), children);
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error @todo find out why TS thinks innerRef has LegacyRef<AnchorHTMLElement> type
    React.createElement("button", Object.assign({
      ref: innerRef,
      type
    }, buttonProps), children)
  );
}
Button.displayName = 'Button';
Button.propTypes = {
  appearance: PropTypes.oneOf(BUTTON_APPEARANCES),
  size: PropTypes.oneOf(BUTTON_SIZES),
  children: buttonLabelValidator(),
  display: PropTypes.oneOf(BUTTON_DISPLAYS),
  Elem: PropTypes.oneOf(BUTTON_ELEMS),
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  extraClasses: PropTypes.string,
  innerRef: InnerRefPropType,
  href: PropTypes.string,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(BUTTON_TYPES)
};
var Button$1 = Injecss(Button, styles);

export { Button, Button$1 as default };
